import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const upsell1 = [['No tenés plantillas de planificación profesionales', '50+ recursos imprimibles listos para usar'], ['No sabés cómo armar una rúbrica desde cero', 'Rúbricas y listas de cotejo listas para entregar'], ['No tenés esquemas tácticos para tus clases', 'Diagramas de deportes listos para imprimir'], ['No tenés registros de seguimiento del alumno', 'Planillas de seguimiento y evaluación completas'], ['Llegás a las prácticas sin material imprimible', 'Todo listo para imprimir desde el primer día']];
const upsell2 = [['Anatomía acumulada sin un resumen útil', 'Guía visual completa con diagramas y glosario'], ['Fisiología sin entender los sistemas energéticos', 'Infografía comparativa lista para estudiar'], ['Psicología del desarrollo sin conectar autores', 'Mapa conceptual con todos los autores clave'], ['Didáctica sin entender los modelos de enseñanza', 'Espectro de Mosston y TGfU explicados visual'], ['Historia de la EF sin una línea de tiempo clara', 'Línea de tiempo completa de la EF argentina']];
function MobilePairList({
  rows,
  label
}: {
  rows: string[][];
  label: string;
}) {
  return <div className="md:hidden space-y-2.5" data-id="element-87">
      {rows.map((row, i) => <motion.div key={i} initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: i * 0.04
    }} className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-88">
          <div className="px-3 py-2 bg-red-50 border-b border-red-100 flex items-start gap-2" data-id="element-89">
            <div className="w-5 h-5 rounded-full bg-red-200 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-90">
              <X className="w-3 h-3 text-red-600" strokeWidth={3} data-id="element-91" />
            </div>
            <p className="text-[11px] text-gray-700 font-medium leading-snug" data-id="element-92">
              {row[0]}
            </p>
          </div>
          <div className="px-3 py-2 bg-brand-50 flex items-start gap-2" data-id="element-93">
            <div className="w-5 h-5 rounded-full bg-brand-600 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-94">
              <Check className="w-3 h-3 text-white" strokeWidth={3} data-id="element-95" />
            </div>
            <p className="text-[11px] text-brand-900 font-bold leading-snug" data-id="element-96">
              {row[1]}
            </p>
          </div>
        </motion.div>)}
    </div>;
}
function DesktopTable({
  rows,
  headerLabel
}: {
  rows: string[][];
  headerLabel: string;
}) {
  return <div className="hidden md:block overflow-x-auto hide-scrollbar pb-4" data-id="element-97">
      <table className="w-full min-w-[600px] bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-200 text-sm" data-id="element-98">
        <thead data-id="element-99">
          <tr className="bg-gray-100 border-b border-gray-200" data-id="element-100">
            <th className="py-3 px-4 text-left font-bold text-gray-700 w-1/3" data-id="element-101">
              Situación actual
            </th>
            <th className="py-3 px-4 text-left font-bold text-gray-700 w-1/3" data-id="element-102">
              Sin Kit Élite
            </th>
            <th className="py-3 px-4 text-left font-bold text-brand-900 bg-brand-50 w-1/3" data-id="element-103">
              {headerLabel}
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100" data-id="element-104">
          {rows.map((row, i) => <tr key={i} className="hover:bg-gray-50 transition-colors" data-id="element-105">
              <td className="py-3 px-4 text-gray-700 font-medium" data-id="element-106">{row[0]}</td>
              <td className="py-3 px-4 text-center text-xl" data-id="element-107">❌</td>
              <td className="py-3 px-4 font-bold text-brand-700 bg-brand-50/30" data-id="element-108">
                ✅ {row[1]}
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}
export function EliteBreakdown() {
  return <section className="py-10 md:py-16 bg-gray-50 border-t border-gray-200" data-id="element-109">
      <div className="max-w-5xl mx-auto px-4" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-111">
          <h2 className="text-2xl md:text-4xl font-black text-brand-950 mb-2 md:mb-4" data-id="element-112">
            ¿Qué agrega el Kit Completo Élite™?
          </h2>
          <p className="text-sm md:text-xl text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-113">
            El sistema para estudiantes que no solo quieren aprobar — quieren
            dominar la carrera
          </p>
        </motion.div>

        {/* Upsell 1 */}
        <div className="mb-8 md:mb-12" data-id="element-114">
          <div className="mb-4 md:mb-6" data-id="element-115">
            <h3 className="text-lg md:text-2xl font-black text-brand-900 mb-1 md:mb-2 leading-tight" data-id="element-116">
              Upsell 1 — Kit de Recursos Visuales para el Docente
            </h3>
            <p className="text-xs md:text-base text-gray-600 italic" data-id="element-117">
              "Todo para tus prácticas docentes y tus primeras clases reales"
            </p>
          </div>
          <MobilePairList rows={upsell1} label="Kit Recursos Visuales" data-id="element-118" />
          <DesktopTable rows={upsell1} headerLabel="Con Kit Recursos Visuales" data-id="element-119" />
        </div>

        {/* Upsell 2 */}
        <div data-id="element-120">
          <div className="mb-4 md:mb-6" data-id="element-121">
            <h3 className="text-lg md:text-2xl font-black text-brand-900 mb-1 md:mb-2 leading-tight" data-id="element-122">
              Upsell 2 — Guías Visuales de las 5 Materias Más Difíciles
            </h3>
            <p className="text-xs md:text-base text-gray-600 italic" data-id="element-123">
              "Las materias que más repiten los estudiantes explicadas en
              infografías y mapas conceptuales"
            </p>
          </div>
          <MobilePairList rows={upsell2} label="Guías Visuales" data-id="element-124" />
          <DesktopTable rows={upsell2} headerLabel="Con Guías Visuales" data-id="element-125" />
        </div>
      </div>
    </section>;
}